import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=0bfabb1e&scoped=true&"
import script from "./LeadsList.vue?vue&type=script&lang=js&"
export * from "./LeadsList.vue?vue&type=script&lang=js&"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=0bfabb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfabb1e",
  null
  
)

export default component.exports